//
import React from "react";
import PropTypes from "prop-types";
import NewletterItem from './NewsletterItem';

const NewsletterList = (props) => (
  <ul className="frontend-elenco-email">{props.list.map(o => <NewletterItem key={o.IdMessage} item={o}/>)}</ul>
);

NewsletterList.propTypes = {
  list: PropTypes.arrayOf(PropTypes.shape({
    IdMessage: PropTypes.number.isRequired,
    IdList: PropTypes.number.isRequired,
    Subject: PropTypes.string.isRequired,
    Notes: PropTypes.string,
    LastUpdated: PropTypes.object
  }))
};

export default NewsletterList;